import React, { useEffect, useState } from "react";
import "../../../StyleSheet/MainComponent/LoginPage/LoginPage.scss";
import Email from "../../AppComponent/InputFields/Email";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import Password from "../../AppComponent/InputFields/Password";
import validator from "validator";
import { useDispatch, useSelector } from "react-redux";
import { getUserAction, setLaguage } from "../../../Redux/Slice";
import logo from "../../../Assets/AppComponent/Logo/Group 56.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import worldimg from "../../../Assets/AppComponent/WorldImgs/Layer_1.png";
import Select from "react-dropdown-select";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import gif from "../../../Assets/loader.gif";
import {
  SetTheCustomerUDSEmployeeLogin,
  setTheIdOne,
  SetTheCustomerUDSEmployeeSendOtp,
  setTheUdsLoginPagechange, ///a page change here
  getUserSuccessAction,
  settheCustomerUDSemployeeloginresponse,
} from "../../../Redux/Slice";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { colors } from "@mui/material";

const LoginPageUDS = (props) => {
  const [Lang, setLang] = useState(1);

  const languageOptions = [
    {
      id: 1,
      value: "English",
    },
    {
      id: 2,
      value: "Hindi",
    },
  ];



  const state = useSelector((state) => state);

  const EnglishData = data;
  const HindiData = hindiDatas;
  const Datas = {
    email: "",
    Password: "",
  };
  const [InputData, setInputDatas] = useState(Datas);
  const [emailorphone, setemailorphone] = useState({ value: "" });
  const [EmailError, setEmailError] = useState("");
  const [PasswordError, setPasswordError] = useState("");
  const [isvalid, setvalid] = useState(true);
  const [validateType, setValidatetype] = useState(null);
  const [verifiedasemail, setverifiedasemail] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const [OTPS, setOTPS] = useState("");
  const [phoneVerifyed, setphoneverifed] = useState(false);
  const [page, setpage] = useState(1);
  const [timer, setTimer] = useState(50);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);

  const handleResendOTP = () => {
    setTimer(50);
    setIsResendDisabled(true);
    HandleTheOtp(); // Function to resend the OTP
  };


  const handleOTPChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value.slice(0, 1);
    if (index < otp.length - 1 && e.target.value !== "") {
      const nextInput = e.target.nextSibling;
      if (nextInput) {
        nextInput.focus();
      }
    }

    setOtp(newOtp);
    var otpVal;
    let newOtpVal = newOtp.filter((char) => char !== "").join("");
    setOTPS(newOtpVal);
    // console.log(otpVal, "otpVal" , newOtp , OTPS);
  };

  useEffect(() => {
    dispatch(setTheUdsLoginPagechange(1));
  }, []);

  const HandleTheOtp = (e) => {
    const payload = {
      logindata: {
        phone_number: emailorphone.value,
      },
      valid: 1,
      api: 1,
      dashboard: 2,
    };
    dispatch(SetTheCustomerUDSEmployeeLogin(payload));
    // dispatch(setTheUdsLoginPagechange(2)); /// for instance
  };
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
    if (e.target.name == "email") {
      const { name, value } = e.target;
      if (!validator.isEmail(value)) {
        setEmailError("*Enter valid mail id");
        setverifiedasemail(false);
      } else {
        setverifiedasemail(true);
      }
    }
  };
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var phoneRegex = /^[0-9]{10}$/;

  // console.log(verifiedasemail, "verifiedasemail2387427");

  const dispatch = useDispatch();

  const handleSubmit = () => {
    var a = 0;
    // localStorage.clear();
if(emailorphone.value == ""){
  setEmailError("*Email or phone number is required");
  a = 1;

}
    if (verifiedasemail === true) {
      if (emailorphone.value == "") {
        setEmailError("*Email or phone number is required");
        a = 1;
      }

      var reg =
        "^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[d]){1,})(?=(.*[W]){1,})(?!.*s).{8,}$";
      if (verifiedasemail && validator.isEmpty(InputData.Password)) {
        setPasswordError("*password is required");
        a = 1;
      }
      if (a == 0) {
        const payload = {
          logindata: {
            email: emailorphone.value,
            password: InputData.Password,
          },
          valid: 2,
          api: 1,
          dashboard: 1,
        };
        dispatch(SetTheCustomerUDSEmployeeLogin(payload));
      }
    }
    if (phoneVerifyed === true) {
      if (emailorphone.value == "") {
        setEmailError("*Email or phone number is required");
        a = 1;
      }
      // if (OTPS == "") {
      //   // setEmailError("*Email or phone number is required");
      // }

      if (a == 0) {
        // const data = {
        //   phone_number: emailorphone.value,
        //   otp: OTPS,

        // };
        const payloads = {
          api: 2,
          logindata: {
            phone_number: emailorphone.value,
            otp: OTPS,
          },
          valid: 1,
          dashboard: 1,
        };
        console.log(payloads, "aoisPA SPOAIS payloads");

        dispatch(SetTheCustomerUDSEmployeeLogin(payloads));

        // dispatch(SetTheCustomerUDSEmployeeSendOtp(payload));
      }
    }
    console.log(a, "asoidas daosid asd", phoneVerifyed, verifiedasemail, emailorphone.value, OTPS);

  };

  const HandleSubmits = (event) => {
    event.preventDefault();
  };
  //-----------------Language---Options---
  useEffect(() => {
    dispatch(setLaguage("English"));
  }, []);
  const LanguageChange = (e) => {
    // console.log(e.target.value, "values");
    // props.onChange(e);

    if (e.target.value == "English") {
      setLang(1);
    } else {
      setLang(0);
    }
    dispatch(setLaguage(e.target.value));
  };
  //--------____Forgot------------_Password-----------
  const handleClick = () => {
    window.location.href = "/forgotpassword";
  };
  const HandleSubmit = (e) => {
    e.preventDefault();
  };

  // setInterval(() => {
  //   dispatch(setTheIdOne(3));
  // }, 6900);

  console.log(state.UDSemployeeRoleActions.PageChange, "sadiaspodi PageChange", verifiedasemail, phoneVerifyed, OTPS);

  return (
    <>
      <div className="uds-loginpage ">
        <div className=" row Conatiningpart">
          <div className="col-md-6 Welcomepart">
            <div className="Toppart">
              <img className="desingimg" src={toppart} />
            </div>
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Welcome.map((item) => (
                      <div className="Content" id={item.id}>
                        <h1>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                )}

              </div>
            </div>
          </div>
          <div className="col-md-6 loginpart">
            <div className="Loginwrapped">
              <div className="Udslog">
                {Lang == 1 ? (
                  <>
                    {EnglishData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.LoginPages.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.LoginHead}
                      </h4>
                    ))}
                  </>
                )}

                <form
                  onSubmit={HandleSubmit}
                //  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className="Input-Inner">
                    {Lang == 1 ? (
                      <>
                        {EnglishData.LeftSide.InputLabel.map((item) => (
                          <>
                            {state.UDSemployeeRoleActions.PageChange == 1 ? (
                              <>
                                <div className="Outer-Inputs">
                                  <label>{"Email or Phone Number"} </label>

                                  <div className="Email inputFields">
                                    <input
                                      onChange={(e) => {
                                        setemailorphone({
                                          ...emailorphone,
                                          value: e.target.value,
                                        });
                                        if (emailRegex.test(e.target.value)) {
                                          setverifiedasemail(true);
                                          setphoneverifed(false);
                                        } else if (
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setverifiedasemail(false);
                                          setphoneverifed(true);
                                        } else if (e.target.value == "") {
                                          setverifiedasemail(false);
                                        } else if (
                                          e.target.value == "" &&
                                          !emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError(
                                            "Must be a valid email or phone number"
                                          );
                                        } else if (
                                          !emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError(
                                            "Must be a valid email or phone number"
                                          );
                                        }

                                        if (
                                          e.target.value != "" &&
                                          emailRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        }
                                        if (
                                          e.target.value != "" &&
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        } else if (
                                          emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        } else if (
                                          !emailRegex.test(e.target.value) &&
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        }
                                      }}
                                    />
                                  </div>
                                  <p
                                    style={{
                                      color: "red",
                                      paddingLeft: "28px",
                                    }}
                                    className="Error"
                                  >
                                    {EmailError}
                                  </p>
                                </div>

                                {verifiedasemail ? (
                                  <Password
                                    value={InputData.Password}
                                    onChange={(e) => {
                                      setPasswordError("");
                                      HandleChanges(e);
                                    }}
                                    Error={PasswordError}
                                    label={item.labelPas}
                                  />
                                ) : (
                                  <>
                                    {!verifiedasemail &&
                                      phoneVerifyed &&
                                      emailorphone.value != "" &&
                                      emailorphone.value.length > 9 ? (
                                      <div
                                        className="SubmitButton"
                                        style={{
                                          display: "flex",
                                          marginLeft: "24px",
                                        }}
                                      >
                                        <CustomButton
                                          children="Submit"
                                          onClick={HandleTheOtp}
                                          type={"submit"}
                                          className="ButtonCSS"
                                          style={{
                                            background: "#F05539",
                                            color: "#fff",
                                          }}
                                        >
                                          {"SEND OTP"}
                                        </CustomButton>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {phoneVerifyed &&
                                  emailorphone.value != "" &&
                                  emailorphone.value.length > 9 ? (
                                  <>
                                    <div className="Outer-Inputs">
                                      <label>{item.labelEm} </label>

                                      <div className="Email inputFields">
                                        <input
                                          value={emailorphone.value}
                                          disabled
                                        />
                                      </div>
                                    </div>

                                    <>
                                      <div className="Outer-Inputs">
                                        <label>{"Otp : "} </label>

                                      </div>
                                      <div className="col-12 Outer-Input OuterOtpBox" style={{ marginLeft: "16px" }}>
                                        <div className="otp-container">
                                          <div className="otp-input">
                                            {otp.map((digit, index) => (
                                              <input
                                                key={index}
                                                type="number"
                                                maxLength="1"
                                                className="OtpNumbers"
                                                value={digit}
                                                onChange={(e) => {
                                                  handleOTPChange(e, index);
                                                }}
                                              />
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="otp-timer OtpTimerBtn">
                                        {isResendDisabled ? (
                                          <p>Resend OTP in {timer} seconds</p>
                                        ) : (
                                          <button onClick={handleResendOTP} className="btn ButtonCSS" disabled={isResendDisabled}>
                                            Resend OTP
                                          </button>
                                        )}
                                      </div>

                                    </>
                                  </>
                                ) : null}
                              </>
                            )}
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {HindiData.LeftSide.InputLabel.map((item) => (
                          <>
                            {state.UDSemployeeRoleActions.PageChange == 1 ? (
                              <>
                                <div className="Outer-Inputs">
                                  <label>{"Email or Phone Number"} </label>

                                  <div className="Email inputFields">
                                    <input
                                      onChange={(e) => {
                                        setemailorphone({
                                          ...emailorphone,
                                          value: e.target.value,
                                        });
                                        if (emailRegex.test(e.target.value)) {
                                          setverifiedasemail(true);
                                          setphoneverifed(false);
                                        } else if (
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setverifiedasemail(false);
                                          setphoneverifed(true);
                                        } else if (e.target.value == "") {
                                          setverifiedasemail(false);
                                        } else if (
                                          e.target.value == "" &&
                                          !emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError(
                                            "Must be a valid email or phone number"
                                          );
                                        } else if (
                                          !emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError(
                                            "Must be a valid email or phone number"
                                          );
                                        }

                                        if (
                                          e.target.value != "" &&
                                          emailRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        }
                                        if (
                                          e.target.value != "" &&
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        } else if (
                                          emailRegex.test(e.target.value) &&
                                          !phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        } else if (
                                          !emailRegex.test(e.target.value) &&
                                          phoneRegex.test(e.target.value)
                                        ) {
                                          setEmailError("");
                                        }
                                      }}
                                    />
                                  </div>
                                  <p
                                    style={{
                                      color: "red",
                                      paddingLeft: "28px",
                                    }}
                                    className="Error"
                                  >
                                    {EmailError}
                                  </p>
                                </div>

                                {verifiedasemail ? (
                                  <Password
                                    value={InputData.Password}
                                    onChange={(e) => {
                                      setPasswordError("");
                                      HandleChanges(e);
                                    }}
                                    Error={PasswordError}
                                    label={item.labelPas}
                                  />
                                ) : (
                                  <>
                                    {!verifiedasemail &&
                                      phoneVerifyed &&
                                      emailorphone.value != "" &&
                                      emailorphone.value.length > 9 ? (
                                      <div
                                        className="SubmitButton"
                                        style={{
                                          display: "flex",
                                          marginLeft: "24px",
                                        }}
                                      >
                                        <CustomButton
                                          children="Submit"
                                          onClick={HandleTheOtp}
                                          type={"submit"}
                                          className="ButtonCSS"
                                          style={{
                                            background: "#F05539",
                                            color: "#fff",
                                          }}
                                        >
                                          {"SEND OTP"}
                                        </CustomButton>
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {phoneVerifyed &&
                                  emailorphone.value != "" &&
                                  emailorphone.value.length > 9 ? (
                                  <>
                                    <div className="Outer-Inputs">
                                      <label>{item.labelEm} </label>

                                      <div className="Email inputFields">
                                        <input
                                          value={emailorphone.value}
                                          disabled
                                        />
                                      </div>
                                    </div>

                                    <>
                                      <div className="Outer-Inputs">
                                        <label>{"Otp : "} </label>

                                      </div>
                                      <div className="col-12 Outer-Input OuterOtpBox">
                                        <div className="otp-container">
                                          <div className="otp-input">
                                            {otp.map((digit, index) => (
                                              <input
                                                key={index}
                                                type="number"
                                                maxLength="1"
                                                className="OtpNumbers"
                                                value={digit}
                                                onChange={(e) => {
                                                  handleOTPChange(e, index);
                                                }}
                                              />
                                            ))}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="otp-timer OtpTimerBtn">
                                        {isResendDisabled ? (
                                          <p>Resend OTP in {timer} seconds</p>
                                        ) : (
                                          <button onClick={handleResendOTP} className="btn ButtonCSS" disabled={isResendDisabled}>
                                            Resend OTP
                                          </button>
                                        )}
                                      </div>
                                    </>
                                  </>
                                ) : null}
                              </>
                            )}
                          </>
                        ))}
                      </>
                    )}
                  </div>
                  <div className="SubmitButton">
                    {Lang == 1 ? (
                      <>
                        {
                          !phoneVerifyed &&
                          EnglishData.LeftSide.Button.Button1.map((item) => (
                            <CustomButton
                              children="Submit"
                              onClick={handleSubmit}
                              type={"submit"}
                              className="ButtonCSS"
                            >
                              {item.ButtonName}
                            </CustomButton>
                          ))}
                        {
                          phoneVerifyed == true &&
                          OTPS != ""
                          &&
                          EnglishData.LeftSide.Button.Button1.map((item) => (
                            <CustomButton
                              children="Submit"
                              onClick={handleSubmit}
                              type={"submit"}
                              className="ButtonCSS"
                            >
                              {item.ButtonName}
                            </CustomButton>
                          ))
                        }
                      </>
                    ) : (
                      <>
                        {!phoneVerifyed &&
                          HindiData.LeftSide.Button.Button1.map((item) => (
                            <CustomButton
                              children="Submit"
                              onClick={handleSubmit}
                              type={"submit"}
                              className="ButtonCSS"
                            >
                              {item.ButtonName}
                            </CustomButton>
                          ))}

                        {phoneVerifyed &&
                          OTPS != "" &&
                          HindiData.LeftSide.Button.Button1.map((item) => (
                            <CustomButton
                              children="Submit"
                              onClick={handleSubmit}
                              type={"submit"}
                              className="ButtonCSS"
                            >
                              {item.ButtonName}
                            </CustomButton>
                          ))}
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPageUDS;
